module.exports = __webpack_public_path__ + "static/img/kldn_bg_320x2.7592b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kldn_bg_320x2.png
// module id = o8SB
// module chunks = 1